import { ThemeProvider } from "next-themes";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HeadProvider } from "react-head";
import App from "./App.jsx";
import "./index.css";
import { setMetaTags } from "./utils/setMetaTags.js";

setMetaTags();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HeadProvider>
      <ThemeProvider attribute="class" defaultTheme="light">
        {/* {landingPage === "enfinity" && <MouseTrailOverlay />} */}
        <App />
      </ThemeProvider>
    </HeadProvider>
  </StrictMode>
);
